// extracted by mini-css-extract-plugin
export default {"primary_btn":"button_primary_btn__R9UNc"};